/*
 * TWD Variant Wise Custom Image Gallery
 * Refactored 2026-07-28.
 * Replaces the server-rendered custom gallery after a variant changes.
 */
(function () {
  if (window.TWDVariantCustomGallery) return;

  window.TWDVariantCustomGallery = {
    update(html, sectionId) {
      const productMedia = document.getElementById(`product-media-${sectionId}`);
      const sourceMedia = html?.getElementById(`product-media-${sectionId}`);
      const isCustomGallery =
        productMedia?.dataset.variantCustomGallery === "true" ||
        sourceMedia?.dataset.variantCustomGallery === "true";

      if (!isCustomGallery) return false;
      if (!sourceMedia || !productMedia) return true;

      const productSlider = document.getElementById(`x-product-${sectionId}`);
      const zoomSlider = document.getElementById(`media-gallery-${sectionId}`);
      if (productSlider?.splide) productSlider.splide.destroy(true);
      if (zoomSlider?.splide) zoomSlider.splide.destroy(true);

      document.getElementById(`ProductModal-${sectionId}`)?.remove();

      // Clone cached response markup so revisiting a previous variant remains reliable.
      const clonedMedia = sourceMedia.cloneNode(true);
      productMedia.replaceWith(clonedMedia);
      if (window.Alpine) window.Alpine.initTree(clonedMedia);

      document.dispatchEvent(
        new CustomEvent(`eurus:media-gallery-ready:${sectionId}`)
      );
      return true;
    },
  };
})();
